import axiosInstance from "../../../axios";
import config from "../../../config";
import { usePersistedStore } from "../../persisted-store";

export const createPageLogReportSlice = (set, get) => ({
    pageLogReports: {
        loading: false,
        data: [],
    },
    getPageLogReportsReports: async (params) => {
        const token = usePersistedStore.getState().business.currentBusiness.token;
        set(state => ({ pageLogReports: { ...state.pageLogReports, loading: true } }));
        try {
            const resp = await axiosInstance({
                method: "post",
                baseURL: 'https://coreapi.bimeh.com',
                url: `/v1/business/Page-Log-Report`,
                data: params,
                headers: { token },
            });
            set(state => ({ pageLogReports: { loading: false, data: resp.data } }));
        } catch (error) {
            set(state => ({ pageLogReports: { ...state.pageLogReports, loading: false } }));
        }
    }
});
